import React, { useState } from "react";
import Header from "../../../components/common/Header/Header";
import "../SettingsPage.css";
import { EyeIcon, EyeOffIcon } from "../../../components/common/Icons/Icons";
import { changePassword } from "../../../redux/actions/user.actions";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/states/root.state";
import ConfirmationModal from "../../../components/common/Modals/ConfirmationModal";

const ChangePassword = () => {
    const dispatch: AppDispatch = useDispatch();
    const isLoading = useSelector((state: RootState) => state.user.loading);
    const [isOpen, setOpen] = useState(false);
    const [modalContent, setContent] = useState("");

    /* Input values to validate and send to db */
    const [oldPassword, setOldPassword] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");

    /* Set show passwords */
    const [showOld, setShowOld] = useState(false); /* Show current password field */
    const [showNew, setShowNew] = useState(false); /* Show both new password fields */

    /* Set errors and helper texts */
    const [oldPasswordError, setOldPasswordError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmError, setConfirmError] = useState("");

    /* Validation and error handling on submit */
    const handleSubmit = async () => {
        /* Reset errors to check again */
        resetErrors();

        /* Handle input errors. No field can be left blank */
        if (oldPassword === ""
            || password === ""
            || passwordConfirmation === "") {
            const blank_error = "Field cannot be left blank."

            if (oldPassword === ""){
                setOldPasswordError(blank_error);
            }

            if (password === ""){
                setPasswordError(blank_error);
            }

            if (passwordConfirmation === ""){
                setConfirmError(blank_error);
            }

        } else {
            const result = await dispatch(
                changePassword({
                  old_password: oldPassword,
                  password: password,
                  password_confirmation: passwordConfirmation
                })
              );
            
            switch(result.type){
                case "user/update-password/rejected":
                    if (result.payload==="The password field confirmation does not match."){
                        setConfirmError("Passwords do not match.");

                    } else if (result.payload==='Old password is incorrect.'){
                        setOldPasswordError("Password is incorrect.");
                    } else {
                        setOpen(true);
                        setContent('An error occurred. Please try again later.');
                    }
                    break;

                case "user/update-password/fulfilled":
                    setOpen(true);
                    setContent('Password Successfully Changed');
                    break;
            }
        }
    }

    const resetErrors = () => {
        setOldPasswordError("");
        setPasswordError("");
        setConfirmError("");
    }

    const passwordField = (
        id: string,
        label: string,
        error: string,
        visible: boolean,
        toggle: () => void,
        onChange: (value: string) => void,
        autoComplete: string,
    ) => (
        <div className="field">
            <label className="field-label" htmlFor={id}>{label}<span className="st-required" aria-hidden="true">*</span></label>
            <div className="st-password">
                <input
                    id={id}
                    className="input"
                    type={visible ? `text`:`password`}
                    onChange={(e)=>onChange(e.target.value)}
                    aria-invalid={error!==""}
                    aria-describedby={`${id}-msg`}
                    autoComplete={autoComplete}
                />
                <button type="button" className="st-password-toggle" onClick={toggle} aria-label={visible ? 'Hide password' : 'Show password'} aria-pressed={visible}>
                    {visible ? <EyeOffIcon/> : <EyeIcon/>}
                </button>
            </div>
            {error && <p id={`${id}-msg`} className="st-field-error">{error}</p>}
        </div>
    );

    return (
        <div className="page st-page">
            <Header withLogo={false} withNavBtn={false} withUserAvatar={false}/>
            <ConfirmationModal isOpen={isOpen} setOpen={setOpen} content={modalContent}/>

            <main className="st-main">
                <div className="st-heading">
                    <h1 className="page-heading">Change password</h1>
                    <p className="st-subheading">Enter your current password, then choose a new one.</p>
                </div>

                <form className="st-form" noValidate onSubmit={(e) => { e.preventDefault(); if (!isLoading) handleSubmit(); }}>
                    <div className="card st-card-body">
                        {passwordField("old-password", "Current password", oldPasswordError, showOld, ()=>setShowOld(!showOld), setOldPassword, "current-password")}
                        {passwordField("new-password", "New password", passwordError, showNew, ()=>setShowNew(!showNew), setPassword, "new-password")}
                        {passwordField("confirm-password", "Confirm new password", confirmError, showNew, ()=>setShowNew(!showNew), setPasswordConfirmation, "new-password")}
                    </div>

                    <div className="st-actions">
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? 'Changing…' : 'Change password'}
                        </button>
                    </div>
                </form>
            </main>
        </div>
    );
};

export default ChangePassword;
